export const stationNumberClass = (ekiNumber, themeName) => {
  if (themeName === 'train') {
    return `c-StationIcon-stationNumber${ekiNumber}-train`
  } else {
    return `c-StationIcon-stationNumber${ekiNumber}`
  }
}
